import * as React from 'react'
// hooks
import { useAuth0 } from '@auth0/auth0-react';

// ----------------------------------------------------------------------
const Login = () => {
    useAuth0().loginWithRedirect();
    return <></>;//<div>Login...</div>;
}

export default Login